import classes from './ComparisonChart.module.scss';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import Image from 'next/image';
import { useMediaQuery } from 'react-responsive';
import { useEffect, useState } from 'react';
import { BRAND_NAME } from '@/utils/constants'

const ComparisonChart = ({ logo }) => {
  const [isMobile, setIsMobile] = useState(true);
  const mobileMedia = useMediaQuery({ query: '(max-width: 767px)' });

  useEffect(() => setIsMobile(mobileMedia), [mobileMedia]);

  const comparisonData = [
    {
      feature: 'Small, Fisherman-Owned',
      sitka: true,
      others: false,
      grocery: false
    },
    {
      feature: 'Caught & Processed in the USA',
      sitka: true,
      others: true,
      grocery: false
    },
    {
      feature: 'No Farmed Species',
      sitka: true,
      others: true,
      grocery: false
    },
    {
      feature: 'Sustainable & Traceable',
      sitka: true,
      others: true,
      grocery: false
    },
    {
      feature: 'Frozen Once',
      sitka: true,
      others: false,
      grocery: false
    },
    {
      feature: 'Wide Variety',
      sitka: true,
      others: false,
      grocery: true
    },
    {
      feature: 'One-Time Purchase & Subscription Options',
      sitka: true,
      others: true,
      grocery: false
    },
    {
      feature: 'No Hassle Guarantee',
      sitka: true,
      others: false,
      grocery: false
    },
    {
      feature: '9-Point Sourcing Criteria',
      sitka: true,
      others: false,
      grocery: false
    },
    {
      feature: 'Provide Fishing Vessel or Processor Name on Packaging',
      sitka: true,
      others: false,
      grocery: false
    },
    {
      feature: 'Comes from Small-Boat Fishermen',
      sitka: true,
      others: false,
      grocery: false
    }
  ];

  return (
    <div className={`${classes.comparison} container`}>
      {isMobile && (
        <h2 className={classes.title}>WHY BUY FROM SITKA SEAFOOD MARKET?</h2>
      )}

      <div className={classes.table}>
        <div className={classes.headers}>
          <div className={classes.headerRow}>
            <div className={classes.featureHeader}>
              {!isMobile && (
                <h2 className={classes.title}>WHY BUY FROM SITKA SEAFOOD MARKET?</h2>
              )}
            </div>
            <div className={classes.companyHeader}>
              {logo?.asset?.url && (
                <Image
                  src={logo.asset.url}
                  alt={BRAND_NAME}
                  width={100}
                  height={50}
                  className={classes.logo}
                />
              )}
            </div>
            <div className={classes.companyHeader}>
              <span>OTHER<br />ONLINE {isMobile? 'SUST.': 'SUSTAINABLE'}<br />FISH SELLERS</span>
            </div>
            <div className={classes.companyHeader}>
              <span>MOST<br />GROCERY STORES</span>
            </div>
          </div>
        </div>

        {comparisonData.map((row, index) => (
          <div key={index} className={classes.row}>
            <div className={classes.feature}>{row.feature}</div>
            <div className={classes.cell}>
              {row.sitka ?
                <CheckIcon className={classes.checkIcon} /> :
                <CloseIcon className={classes.closeIcon} />
              }
            </div>
            <div className={classes.cell}>
              {row.others ?
                <CheckIcon className={classes.checkIcon} /> :
                <CloseIcon className={classes.closeIcon} />
              }
            </div>
            <div className={classes.cell}>
              {row.grocery ?
                <CheckIcon className={classes.checkIcon} /> :
                <CloseIcon className={classes.closeIcon} />
              }
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ComparisonChart;